import { useEffect, useState } from "react";
import API from "../api/api";
import AdminLayout from "../layouts/AdminLayout";
import {
    useAuth
} from "../context/AuthContext";

export default function Users() {
     const { hasPermission } = useAuth();

    const canManagePermissions =
        hasPermission("manage_permissions");
    const [users, setUsers] = useState([]);
const [permissionGroups, setPermissionGroups] = useState([]);
const [editingUser, setEditingUser] = useState(null);
const [roleFilter, setRoleFilter] = useState("all");
    
    



    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        role: "guide",
        permissions: []
    });




    const loadUsers = async () => {

        try {

            const res =
                await API.get("/admin/users");

            setUsers(res.data);

        } catch (err) {

            console.error(err);

            alert(
                err.response?.data?.error ||
                "Could not load users"
            );

        }

    };


    const loadPermissions = async () => {

        try {

            const res =
                await API.get(
                    "/admin/users/permissions"
                );

            setPermissionGroups(res.data);

        } catch (err) {

            console.error(err);

        }

    };


    useEffect(() => {
        loadUsers();
        loadPermissions();

    }, []);


    const resetForm = () => {

        setEditingUser(null);

        setForm({
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            role: "guide",
            permissions: []
        });

    };


    const editUser = (user) => {

        setEditingUser(user.id);

        let permissions = [];

        if (Array.isArray(user.permissions)) {

            permissions = user.permissions;

        } else if (typeof user.permissions === "string") {

            try {

                permissions =
                    JSON.parse(user.permissions);

            } catch {

                permissions = [];

            }

        }


        setForm({
            first_name: user.first_name || "",
            last_name: user.last_name || "",
            email: user.email || "",
            password: "",
            role: user.role,
            permissions
        });

    };


    const toggleUserPermission = (permission) => {

        setForm(prev => {

            const exists =
                prev.permissions.includes(permission);

            return {
                ...prev,
                permissions: exists
                    ? prev.permissions.filter(
                        p => p !== permission
                    )
                    : [
                        ...prev.permissions,
                        permission
                    ]
            };

        });

    };


    const saveUser = async () => {

        try {

            if (!editingUser) {

                await API.post(
                    "/admin/users",
                    form
                );

                alert("User created");

            } else {

                await API.put(
                    `/admin/users/${editingUser}`,
                    {
                        first_name: form.first_name,
                        last_name: form.last_name,
                        email: form.email,
                        role: form.role,
                        permissions: form.permissions
                    }
                );

                alert("User updated");

            }


            resetForm();

            loadUsers();

        } catch (err) {

            console.error(err);

            alert(
                err.response?.data?.error ||
                "Could not save user"
            );

        }

    };


    const deleteUser = async (id) => {

        if (
            !window.confirm(
                "Are you sure you want to delete this user?"
            )
        ) {
            return;
        }


        try {

            await API.delete(
                `/admin/users/${id}`
            );

            loadUsers();

        } catch (err) {

            console.error(err);

            alert(
                err.response?.data?.error ||
                "Could not delete user"
            );

        }

    };
const isMobile = window.innerWidth < 900;
    const visiblePermissionGroups =
    permissionGroups.filter(
        group =>
            group.role === form.role
    );

const filteredUsers =
    roleFilter === "all"
        ? users
        : users.filter(
            user => user.role === roleFilter
        );


    return (
        <AdminLayout>

            <div style={page}>

                <div style={header}>

                    <div>
                        <h1 style={title}>
                            User Management
                        </h1>

                        <p style={subtitle}>
                            Create and manage administrator,
guide and coordinator accounts.
                        </p>
                    </div>

                    <button
                        style={newButton}
                        onClick={resetForm}
                    >
                        + New User
                    </button>

                </div>


                <div
    style={{
        ...layout,
        ...(isMobile && {
            gridTemplateColumns: "1fr"
        })
    }}
>

                    {/* =========================
                        USER LIST
                    ========================= */}

                    <div style={card}>

    <div style={userListHeader}>

        <h2 style={{ margin: 0 }}>
            Users
        </h2>

        <select
            style={filterSelect}
            value={roleFilter}
            onChange={e =>
                setRoleFilter(e.target.value)
            }
        >
            <option value="all">
                All Users
            </option>

            <option value="guide">
    Guide
</option>

<option value="coordinator">
    Coordinator
</option>

<option value="admin">
    Administrator
</option>
        </select>

    </div>


    {filteredUsers.length === 0 && (
                            <p>
                                No users found.
                            </p>
                        )}


                        {filteredUsers.map(user => (

                            <div
                                key={user.id}
                                style={userRow}
                            >

                                <div style={{ minWidth: 0, flex: 1 }}>

                                    <strong>
                                        {user.first_name}{" "}
                                        {user.last_name}
                                    </strong>

                                    <div style={email} title={user.email || ""}>
                                        {user.email}
                                    </div>

                                    <div style={roleBadge}>
                                        {user.role === "admin"
    ? "Administrator"
    : user.role === "coordinator"
        ? "Coordinator"
        : "Guide"}

                                        {user.is_super_admin
                                            ? " • Super Admin"
                                            : ""}
                                    </div>

                                </div>


                                <div style={actions}>

                                    <button
                                        style={editButton}
                                        onClick={() =>
                                            editUser(user)
                                        }
                                    >
                                        Edit
                                    </button>

                                    <button
                                        style={deleteButton}
                                        onClick={() =>
                                            deleteUser(user.id)
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </div>

                        ))}

                    </div>


                    {/* =========================
                        USER FORM
                    ========================= */}

                    <div style={card}>

                        <h2>
                            {editingUser
                                ? "Edit User"
                                : "Create User"}
                        </h2>


                        <input
                            style={input}
                            placeholder="First name"
                            value={form.first_name}
                            onChange={e =>
                                setForm({
                                    ...form,
                                    first_name:
                                        e.target.value
                                })
                            }
                        />


                        <input
                            style={input}
                            placeholder="Last name"
                            value={form.last_name}
                            onChange={e =>
                                setForm({
                                    ...form,
                                    last_name:
                                        e.target.value
                                })
                            }
                        />


                        <input
                            style={input}
                            type="email"
                            placeholder="Email"
                            value={form.email}
                            onChange={e =>
                                setForm({
                                    ...form,
                                    email:
                                        e.target.value
                                })
                            }
                        />


                        {!editingUser && (
                            <input
                                style={input}
                                type="password"
                                placeholder="Password"
                                value={form.password}
                                onChange={e =>
                                    setForm({
                                        ...form,
                                        password:
                                            e.target.value
                                    })
                                }
                            />
                        )}


                        <select
                            style={input}
                            value={form.role}
                            onChange={e =>
    setForm({
        ...form,
        role: e.target.value,
        permissions: []
    })
}
                        >

                            <option value="guide">
                                Guide
                            </option>

                            <option value="admin">
    Administrator
</option>

<option value="coordinator">
    Coordinator
</option>

                        </select>


                        {/* =====================
                            ADMIN PERMISSIONS
                        ===================== */}

                        {(
    form.role === "guide" ||
    (form.role === "admin" && canManagePermissions)
) && (

    <div style={permissionsBox}>

                               <h3>
    {form.role === "guide"
        ? "Guide Permissions"
        : "Administrator Permissions"}
</h3>

<p style={permissionHelp}>
    {form.role === "guide"
        ? "Choose what this guide is allowed to do."
        : "Choose what this administrator is allowed to access."}
</p>


                                {visiblePermissionGroups.map(
    group => (

                                        <div
                                            key={group.key}
                                            style={permissionGroup}
                                        >

                                            <strong>
                                                {group.label}
                                            </strong>


                                            {group.permissions.map(
                                                permission => (

                                                   <label
    key={permission.key}
    style={permissionRow}
>

    <input
        type="checkbox"
        checked={
            form.permissions.includes(
                permission.key
            )
        }
        onChange={() =>
            toggleUserPermission(
                permission.key
            )
        }
    />

    <div>

        <div style={permissionName}>
            {permission.label}
        </div>

        {permission.description && (
            <div style={permissionDescription}>
                {permission.description}
            </div>
        )}

    </div>

</label>

                                                )
                                            )}

                                        </div>

                                    )
                                )}

                            </div>

                        )}


                        <div style={formButtons}>

                            <button
                                style={saveButton}
                                onClick={saveUser}
                            >
                                {editingUser
                                    ? "Save Changes"
                                    : "Create User"}
                            </button>


                            {editingUser && (

                                <button
                                    style={cancelButton}
                                    onClick={resetForm}
                                >
                                    Cancel
                                </button>

                            )}

                        </div>

                    </div>

                </div>

            </div>

        </AdminLayout>
    );
}


/* =========================
   STYLES
========================= */

const page = {
    padding: "24px",
    background: "#f5f6f8",
    minHeight: "100vh",
    boxSizing: "border-box",
    color: "#172033"
};

const header = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 16,
    marginBottom: 22
};

const title = {
    margin: 0,
    fontSize: 25,
    lineHeight: 1.2,
    fontWeight: 700,
    color: "#172033"
};

const subtitle = {
    marginTop: 6,
    marginBottom: 0,
    color: "#7b8798",
    fontSize: 13
};

const layout = {
    display: "grid",
    gridTemplateColumns: "minmax(300px, 0.95fr) minmax(380px, 1.25fr)",
    gap: 18,
    alignItems: "start",
    width: "100%"
};

const card = {
    minWidth: 0,
    boxSizing: "border-box",
    background: "#ffffff",
    border: "1px solid #e1e6ed",
    borderRadius: 13,
    padding: 20,
    boxShadow: "0 2px 8px rgba(25, 35, 50, 0.035)"
};

const userListHeader = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginBottom: 12
};

const filterSelect = {
    maxWidth: "100%",
    boxSizing: "border-box",
    padding: "9px 11px",
    border: "1px solid #dce2e9",
    borderRadius: 8,
    background: "#ffffff",
    color: "#344054",
    fontSize: 13,
    cursor: "pointer"
};

const input = {
    display: "block",
    width: "100%",
    boxSizing: "border-box",
    padding: "11px 12px",
    marginBottom: 12,
    border: "1px solid #dce2e9",
    borderRadius: 8,
    background: "#ffffff",
    color: "#172033",
    fontSize: 13,
    outlineColor: "#c75028"
};

const userRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    minWidth: 0,
    padding: "14px 0",
    borderBottom: "1px solid #edf0f4"
};

const email = {
    display: "block",
    width: "100%",
    maxWidth: "220px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: 12,
    color: "#8290a3",
    marginTop: 4
};

const roleBadge = {
    display: "inline-block",
    maxWidth: "100%",
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginTop: 7,
    padding: "4px 8px",
    borderRadius: 6,
    background: "#fff1e9",
    color: "#b94b26",
    fontSize: 11,
    fontWeight: 600
};

const actions = {
    display: "flex",
    flexShrink: 0,
    gap: 6
};

const newButton = {
    padding: "10px 15px",
    border: "1px solid #c75028",
    borderRadius: 8,
    background: "#c75028",
    color: "#ffffff",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap"
};

const editButton = {
    padding: "7px 10px",
    border: "1px solid #dce2e9",
    borderRadius: 7,
    background: "#ffffff",
    color: "#344054",
    fontSize: 12,
    cursor: "pointer"
};

const deleteButton = {
    padding: "7px 10px",
    border: "1px solid #f3d4d1",
    borderRadius: 7,
    background: "#fff5f4",
    color: "#b5473c",
    fontSize: 12,
    cursor: "pointer"
};

const permissionsBox = {
    minWidth: 0,
    boxSizing: "border-box",
    marginTop: 10,
    marginBottom: 15,
    padding: 15,
    background: "#f8f9fb",
    borderRadius: 9,
    border: "1px solid #e4e8ee"
};

const permissionHelp = {
    fontSize: 12,
    color: "#7b8798",
    lineHeight: 1.5
};

const permissionGroup = {
    padding: "12px 0",
    borderBottom: "1px solid #e7ebf0"
};

const permissionRow = {
    display: "flex",
    gap: 9,
    alignItems: "flex-start",
    marginTop: 9,
    fontSize: 13,
    color: "#344054",
    cursor: "pointer"
};

const permissionName = {
    fontSize: 13,
    fontWeight: 600,
    color: "#263247"
};

const permissionDescription = {
    fontSize: 11,
    color: "#8290a3",
    marginTop: 3,
    lineHeight: 1.45
};

const formButtons = {
    display: "flex",
    flexWrap: "wrap",
    gap: 9,
    marginTop: 15
};

const saveButton = {
    padding: "10px 16px",
    border: "1px solid #c75028",
    borderRadius: 8,
    background: "#c75028",
    color: "#ffffff",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer"
};

const cancelButton = {
    padding: "10px 16px",
    border: "1px solid #dce2e9",
    borderRadius: 8,
    background: "#ffffff",
    color: "#475467",
    fontSize: 13,
    cursor: "pointer"
};
